module.exports = "<plate-colorpicker [displayButton]=\"false\"\n                   [isMetalColorSelectable]=\"isMetalColorSelectable\"\n                   [isRalColorSelectable]=\"isRalColorSelectable\"\n                   [allowMattGlossySelection]=\"allowMattGlossySelection\"\n                   [isMobileMode]=\"isMobileMode\"\n                   (colorSelected)=\"colorSelected($event)\"\n                   (requestClose)=\"closeDialog()\"></plate-colorpicker>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/plate-colorpicker-dialog/plate-colorpicker-dialog.component.html
// module id = wzE8
// module chunks = 5